import CircularProgress from '@mui/material/CircularProgress';

export const Loader = () => {
    return <CircularProgress />
}